<template>
<v-layout
    row
    :style="maxWidth"
>
<v-flex
    class="ml-3"
    :style="maxWidth"
>
    <v-card
        class="mx-auto"
        tile
        v-if="outlet.bg_image"
        max-height="400"
    >
        <v-img
            v-if="outlet.logo"
            :src="myLogo"
            class="my-logo"
            alt="logo"
            max-height="100"
            max-width="100"
            style="margin-left: -50px;top: 50%;z-index: 200;position: absolute;left: 50%;"
            contain
        />
        <v-img
            class="white--text align-end"
            :src="myBackground"
            alt="background"
            max-height="400"
        >
            <v-card-text
                :style="sloganStyle"
            >
                {{ outlet.slogan }}
            </v-card-text>
        </v-img>
    </v-card>
    <v-snackbar
        v-model="success"
        color="success"
        :timeout="5000"
        top
    >
        Added to Queue!
    </v-snackbar>
    <v-snackbar
        v-model="error"
        color="error"
        :timeout="5000"
        top
    >
        {{ error_msg }}
    </v-snackbar>
    <v-container>
        <div
            style="text-align: center"
        >
            <div
                class="col-sm-12"
                style="display: inline-block;"
                v-for="(queue, index) in queues"
            >
                <v-btn
                    :class="btnFontClass"
                    :key="index"
                    x-large
                    :color="btnColor"
                    :style="btnTextSize(queue)"
                    @click="goToQueue(queue)"
                >
                    {{ queue.name }}
                </v-btn>
            </div>
        </div>
    </v-container>
</v-flex>
</v-layout>
</template>

<script>
export default {
    name: 'outlet',
    props: ['outlet', 'queues'],
    data: () => {
        return {
            showQueueForm: false,
            name: '',
            phone: '',
            email: '',
            remarks: '',
            customContent: '',
            internationalPhone: '',
            selectedQueue: '',
            success: false,
            error: false,
            error_msg: '',
            queueLength: 0,
            estimateTime: '',
            longQueue: false,
            mobileIsValid: false,
            showConfirm: false,
            countryCodes: [
                {'flag': '🇸🇬', 'country_code': 65, 'name': 'Singapore'},
                {'flag': '🇨🇳', 'country_code': 86, 'name': 'China'},
                {'flag': '🇭🇰', 'country_code': 852, 'name': 'Hong Kong SAR China'},
                {'flag': '🇲🇾', 'country_code': 60, 'name': 'Malaysia'},
            ],
            available: true,
            hasServices: false,
            qServices: null,
            selectedServices: '',
            pax: 1,
            printerIP: null,
            q_no: '',
            showDetails: false,
            showDeclaration: false,
            timeout: null,
            isLoading: null,
            appointment_time: null,
            travel: null,
            symptoms: null,
            servingNotice: null,
            closeContact: null,
            tempQ: null,
            declarationAlert: false,
            declarationMsg: null,
            screensaver: null,
            // queues: []
        }
    },
    computed: {
        formStyle() {
            return {
                backgroundColor: this.outlet.main_color ? this.outlet.main_color : 'black',
                color: this.outlet.main_font_color ? this.outlet.main_font_color : 'white',
                fontWeight: "bold",
                fontSize: "50px"
            }
        },
        confirmStyle() {
            return {
                fontSize: "30px"
            }
        },
        myBackground() {
            return '/storage' + this.outlet.bg_image;
        },
        myScreenSaver() {
            return this.outlet.screen_saver_img ? '/storage' + this.outlet.screen_saver_img : '/storage' + this.outlet.bg_image;
        },
        myLogo() {
            return '/storage' + this.outlet.logo;
        },
        btnColor() {
            return this.outlet.main_color ? this.outlet.main_color : 'black';
        },
        btnFontClass() {
            let c = this.outlet.main_font_color ? this.outlet.main_font_color : 'white';
            return c + '--text'
        },
        sloganStyle() {
            return {
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '40px',
                color: this.outlet.slogan_color ? this.outlet.slogan_color : '#000000'
            }
        },
        maxWidth() {
            return {
                maxWidth: window.outerWidth + 'px'
            }
        },
    },
    methods: {
        btnTextSize(q) {
            let size = 'large';
            if (q.name.length > 20 && q.name.length < 30) size = 'large';
            if (q.name.length > 30) size = 'medium';

            if (window.innerWidth < 500) {
                size = '12px'
            }
            return {
                fontSize: size,
                fontWeight: 'bold',
                marginTop: '16px',
                marginBottom: '16px',
            }
        },
        goToQueue(q) {
            window.location.href = '/outlet/' + this.outlet.id + '/queue/' + q.id

        }
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Outlets/Online.vue